/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChipAi = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 17.5A2.5 2.5 0 0 0 6.5 20H7v2h-.5A4.5 4.5 0 0 1 2 17.5V17h2zm7 4.5H9v-2h2zm4 0h-2v-2h2zm7-4.5a4.5 4.5 0 0 1-4.269 4.494L17.5 22H17v-2h.5a2.5 2.5 0 0 0 2.487-2.244L20 17.5V17h2zM14.071 16h-2.434l-.405-1.387h-2.49L8.346 16H6l2.95-8h2.15zm-4.848-3.081h1.513l-.766-2.626zM17 16h-2.192V8H17zM4 15H2v-2h2zm18 0h-2v-2h2zM4 11H2V9h2zm18 0h-2V9h2zM7 4h-.5A2.5 2.5 0 0 0 4 6.5V7H2v-.5A4.5 4.5 0 0 1 6.5 2H7zm10.5-2A4.5 4.5 0 0 1 22 6.5V7h-2v-.5A2.5 2.5 0 0 0 17.5 4H17V2zM11 4H9V2h2zm4 0h-2V2h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChipAi as ChipAi };
